import { MprcFeedTypography } from "components/MprcFeedTypography";
import { Formaters } from "lib/Formaters";
import { useTranslation } from "react-i18next";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";

export const ContentDeleted = () => {
    const {
        pub: { deletedOn },
    } = useCardContext();
    const { t } = useTranslation("knowledge");

    return deletedOn
        ? (
            <>
                <MprcFeedTypography variant="content" component="div">
                    <span>{`${t("Feed.Card.Common.ContentDeletedText")} ${Formaters.relativeTime(deletedOn)}`}</span>
                </MprcFeedTypography>
            </>
        )
        : null;
};
